import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StatusBadgeContainer = styled.div`
  padding: 8px 8px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid;
  background: ${(props) => {
    switch (props.status) {
      case 'DRAFT':
        return ({ theme }) => theme.primary.background;
      case 'TRANSACTION_PENDING':
        return ({ theme }) => theme.status.warning.background;
      case 'TRANSACTION_FAILED':
        return ({ theme }) => theme.status.error.background;
      case 'SENT':
        return ({ theme }) => theme.status.success.light;
      case 'COMMUNICATION_FAILED':
        return ({ theme }) => theme.status.error.background;
      case 'CLAIMED':
        return ({ theme }) => theme.status.success.light;
      case 'ERROR':
        return ({ theme }) => theme.status.error.background;
      case 'HTLC_CREATED':
      case 'TRIAL_CREATED':
        return ({ theme }) => theme.status.warning.background;
      case 'HTLC_CLAIMED':
        return ({ theme }) => theme.status.success.light;
      case 'HTLC_REFUNDED':
        return ({ theme }) => theme.status.warning.background;
      default:
        return ({ theme }) => theme.primary.background;
    }
  }};
  border-color: ${(props) => {
    switch (props.status) {
      case 'DRAFT':
        return ({ theme }) => theme.primary.ultraLight;
      case 'TRANSACTION_PENDING':
        return ({ theme }) => theme.status.warning.lighter;
      case 'TRANSACTION_FAILED':
        return ({ theme }) => theme.status.error.primary;
      case 'SENT':
        return ({ theme }) => theme.status.success.lighter;
      case 'COMMUNICATION_FAILED':
        return ({ theme }) => theme.status.error.primary;
      case 'CLAIMED':
        return ({ theme }) => theme.status.success.lighter;
      case 'ERROR':
        return ({ theme }) => theme.status.error.primary;
      case 'HTLC_CREATED':
      case 'TRIAL_CREATED':
        return ({ theme }) => theme.status.warning.lighter;
      case 'HTLC_CLAIMED':
        return ({ theme }) => theme.status.success.lighter;
      case 'HTLC_REFUNDED':
        return ({ theme }) => theme.status.warning.lighter;
      default:
        return ({ theme }) => theme.primary.ultraLight;
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case 'DRAFT':
        return ({ theme }) => theme.text.secondary;
      case 'TRANSACTION_PENDING':
        return ({ theme }) => theme.text.warning;
      case 'TRANSACTION_FAILED':
        return ({ theme }) => theme.text.error;
      case 'SENT':
        return ({ theme }) => theme.text.success;
      case 'COMMUNICATION_FAILED':
        return ({ theme }) => theme.text.error;
      case 'CLAIMED':
        return ({ theme }) => theme.text.success;
      case 'ERROR':
        return ({ theme }) => theme.text.error;
      case 'HTLC_CREATED':
      case 'TRIAL_CREATED':
        return ({ theme }) => theme.text.warning;
      case 'HTLC_CLAIMED':
        return ({ theme }) => theme.text.success;
      case 'HTLC_REFUNDED':
        return ({ theme }) => theme.text.warning;
      default:
        return ({ theme }) => theme.text.secondary;
    }
  }};
`;

const StatusBadge = ({ status, type, deliveryStatus }) => {
  const { t } = useTranslation();

  const getStatusText = () => {
    if (type === 'PHYSICAL') {
      switch (deliveryStatus) {
        case 'pending':
          return t('statusBadge.pendingDelivery');
      }
      switch (status) {
        case 'HTLC_CREATED':
        case 'TRIAL_CREATED':
          return t('statusBadge.pendingClaim');
        case 'HTLC_CLAIMED':
          return t('statusBadge.claimed');
        case 'HTLC_REFUNDED':
          return t('statusBadge.refunded');
      }
    }
    switch (status) {
      case 'DRAFT':
        return t('statusBadge.draft');
      case 'TRANSACTION_PENDING':
        return t('statusBadge.processing');
      case 'TRANSACTION_FAILED':
        return t('statusBadge.failed');
      case 'SENT':
        return t('statusBadge.sent');
      case 'COMMUNICATION_FAILED':
        return t('statusBadge.notificationFailed');
      case 'CLAIMED':
        return t('statusBadge.claimed');
      case 'ERROR':
        return t('statusBadge.error');
      case 'HTLC_CREATED':
      case 'TRIAL_CREATED':
        return t('statusBadge.pendingClaim');
      case 'HTLC_CLAIMED':
        return t('statusBadge.claimed');
      case 'HTLC_REFUNDED':
        return t('statusBadge.refunded');
      default:
        return status || t('statusBadge.unknown');
    }
  };

  return (
    <StatusBadgeContainer status={status}>
      {getStatusText()}
    </StatusBadgeContainer>
  );
};

export default StatusBadge;
